export default __webpack_public_path__ + "static/media/ic-setup.4e98a867.svg";